export default __webpack_public_path__ + "static/media/hht2_Intonation_07.a7919485.png";